import {ViolationTargetModel} from './ViolationTarget.model';
import {cartV2} from '@wix/ecom';

export class ViolationModel {
  public severity: ViolationSeverity;
  public target: ViolationTargetModel;
  public description: string;

  constructor(params: ViolationModel) {
    this.severity = params.severity;
    this.target = params.target;
    this.description = params.description;
  }

  public static fromCartV2Old(violation: cartV2.Violation): ViolationModel {
    return new ViolationModel({
      severity: severityMap(violation.severity as cartV2.Severity),
      target: ViolationTargetModel.fromCartV2(violation.target),
      description: violation.description,
    });
  }
  public static fromCartV2(violation: cartV2.V2Violation): ViolationModel {
    return new ViolationModel({
      severity:
        violation.severity === cartV2.ViolationSeverity.ERROR ? ViolationSeverity.error : ViolationSeverity.warning,
      target: ViolationTargetModel.fromCartV2(violation.customValidationData.target),
      description: violation.description,
    });
  }
}

const severityMap = (severity: cartV2.Severity) => {
  const map: Record<cartV2.Severity, ViolationSeverity> = {
    [cartV2.Severity.ERROR]: ViolationSeverity.error,
    [cartV2.Severity.WARNING]: ViolationSeverity.warning,
  };

  return map[severity];
};

export enum ViolationSeverity {
  error = 'ERROR',
  warning = 'WARNING',
}
